import type { GoogleSlidesStaticContent } from '@core-api/editor/types/response';
import { usePresentationSlideContext } from '../../legacy-context/presentationContext';
import { EmbedIntegrationPresentation } from '../../shared/components/embed-integrations/EmbedIntegrationPresentation';
import { buildGoogleSlidesURL, isValidGoogleSlidesURL } from './utils';

export function GoogleSlidesPresentation() {
  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as GoogleSlidesStaticContent;

  return (
    <EmbedIntegrationPresentation
      integrationName="Google Slides"
      presentationUrl={buildGoogleSlidesURL(
        staticContent.url,
        staticContent.startingSlideNumber ?? 1,
      )}
      isValidUrl={isValidGoogleSlidesURL}
    />
  );
}
